import Swipe from 'swipejs';

export function activateSlider() {
    if (document.getElementById('news-slider') !== null) {
        const mobileDots = document.querySelectorAll('.mobile-slider-dots .dot');
        const newsSlider = new Swipe(document.getElementById('news-slider'), {
            startSlide: 0,
            auto: 3000,
            draggable: true,
            autoRestart: false,
            continuous: true,
            disableScroll: true,
            stopPropagation: true,
            callback: (index, element) => {
                mobileDots.forEach(function (x) {
                    x.classList.remove('active');
                });
                if (mobileDots[index]) {
                    mobileDots[index].classList.add('active');
                }
            },
        });

        mobileDots.forEach((dot, index) => {
            dot.addEventListener('click', (event) => {
                newsSlider.slide(index);
            })
        });
    }
}
